export default function(ctx) {
var __t, __p = '';
__p += '<div class="canvas-wrapper">\n	<canvas data-canvas></canvas>\n</div>';
return __p
}